import { useSelector } from '~/_shared/utils/hooks/useSelector';
import type { AppState } from '~/store/app.store';
import { type BoundaryTerritoryGroupId } from '~/store/boundaries/boundaryIdentifier.type';

export const extraFillConfigPerBTGIdSelector = (state: AppState) => {
  return state.frontendState.boundaryTerritoryTool.extraFillDataPerBTGId;
};

export const useExtraFillConfigSelector = (btgId?: BoundaryTerritoryGroupId | null) => {
  const extraFillInfosPerBTG = useSelector(extraFillConfigPerBTGIdSelector);
  if (btgId) {
    return extraFillInfosPerBTG[btgId];
  }
  return null;
};

export const defaultFillFilterHashPerBTGIdSelector = (state: AppState) => {
  return state.frontendState.boundaryTerritoryTool.defaultFillFilterHashPerBTGId;
};

export const extraFillInfoPerFillIdSelector = (state: AppState) => {
  return state.frontendState.boundaryTerritoryTool.extraFillInfoPerFillId;
};

export const fillFiltersSelector = (state: AppState) => {
  return state.frontendState.boundaryTerritoryTool.fillFilters;
};

const extraFillDataSelector = (state: AppState, boundaryTerritoryGroupId: BoundaryTerritoryGroupId) => {
  return state.frontendState.boundaryTerritoryTool.extraFillDataPerBTGId[boundaryTerritoryGroupId];
};

const extraFillsSelector = (state: AppState, boundaryTerritoryGroupId: BoundaryTerritoryGroupId) => {
  return extraFillDataSelector(state, boundaryTerritoryGroupId)?.extraFills;
};

const activeFillIdSelector = (state: AppState, boundaryTerritoryGroupId: BoundaryTerritoryGroupId) => {
  return extraFillDataSelector(state, boundaryTerritoryGroupId)?.activeBoundaryFillId;
};

export const useExtraFillsSelector = (boundaryTerritoryGroupId: BoundaryTerritoryGroupId) => {
  return useSelector((state: AppState) => extraFillsSelector(state, boundaryTerritoryGroupId));
};

export const useActiveFillIdSelector = (boundaryTerritoryGroupId: BoundaryTerritoryGroupId) => {
  return useSelector((state: AppState) => activeFillIdSelector(state, boundaryTerritoryGroupId));
};
